import { Controller } from "@hotwired/stimulus"

// Trix doesn't support target="_blank", so we need this hacky workaround until the featured lots are implemented:
// https://github.com/basecamp/trix/issues/55
export default class extends Controller {
  connect() {
    this.element.querySelectorAll("a").forEach(element => {
      element.setAttribute("target", "_blank")
    })
  }
}
